export const CONFIG = 'CONFIG'

export const setConfig = (config) => {
  return {
    type: CONFIG,
    config
  }
}
